var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationEndDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.75C13 0.335786 12.6642 0 12.25 0C11.8358 0 11.5 0.335786 11.5 0.75L11.5 13.25C11.5 13.6642 11.8358 14 12.25 14C12.6642 14 13 13.6642 13 13.25L13 0.75ZM2.03033 0.46967C1.73744 0.176777 1.26256 0.176777 0.96967 0.46967C0.676777 0.762563 0.676777 1.23744 0.96967 1.53033L6.43934 7L0.96967 12.4697C0.676777 12.7626 0.676777 13.2374 0.96967 13.5303C1.26256 13.8232 1.73744 13.8232 2.03033 13.5303L8.03033 7.53033C8.32322 7.23744 8.32322 6.76256 8.03033 6.46967L2.03033 0.46967Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationEndDisabled);
export default __webpack_public_path__ + "static/media/PaginationEndDisabled.732db59ee66d2b0d3620d0096db62a9e.svg";
export { ForwardRef as ReactComponent };